import React from 'react';
import { Alert, AlertContext, Form } from '../../components';
import ApiService from '../../services/api.service';

interface IProps { 
    history?: any;
    id?: number;
    caption?: string;
    captionColor?: any;
    buttonCaption?: string;
    endPoint?: string;
    endPointFilter?: string;
    model: any;
    onLoad?: (data: any) => void;
    onError?: (data: any) => void;
    onSave?: (data: any) => void;
    save?: boolean;
    buttonOnBottom?: boolean;
    cardColor?: any;
    cardGradientColor?: any;
    disableAutoBack?: boolean;
    disableBackButton?: boolean;
    disableCard?: boolean;
    children?: React.ReactNode;
}

interface IState {
    endPointFilter: string;
}

export default class BaseShare extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            endPointFilter: props.endPointFilter || '',
        }
    }
    
    static contextType = AlertContext;

    private id = () => this.props.id?.toString() || this.props.history?.location.state?.id || '';
    private isLoading: boolean = false;
    private isSaving: boolean = false;
    
    private onSave = () => {
        this.isSaving = true;
        this.props.onSave?.(null);
        if (!this.props.disableAutoBack) this.props.history?.goBack();
        this.isSaving = false;
    }

    public componentDidMount() { 
        if (this.isLoading) return;
        this.isLoading = true;
        
        ApiService.get<typeof this.props.model>((this.props.endPoint||this.props.model.endPoint) + (this.props.endPointFilter || '?populate=*&filters[id]='), this.id())
        .then(rp => {
            if (rp.Status) { 
                var data = rp.Data.length === 0? this.props.model.defaultValue() : new this.props.model(rp.Data[0]); 
                this.props.onLoad?.(data);
            }
            else Alert(this.context, rp.Messages, 'error');
            this.isLoading = false;
        });
    }
    
    public componentDidUpdate() {
        if (!this.isLoading)
            if (this.props.endPointFilter && this.state.endPointFilter !== this.props.endPointFilter) {
                this.setState({endPointFilter: this.props.endPointFilter})
                this.componentDidMount();
            }

        if (this.props.save && !this.isSaving) this.onSave();
    }

    render() {
        return (
        <Form history={this.props.history} caption={this.props.caption || 'Share ' + this.props.model.caption} captionColor={this.props.captionColor} buttonCaption={this.props.buttonCaption || 'share'} buttonOnBottom={this.props.buttonOnBottom} onSubmit={this.onSave} cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
            {this.props.children}
        </Form>
        );
    }
}